module.exports = __webpack_public_path__ + "static/media/ENGLong2w427@2x.86498f2d.jpg";